import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const processFunctionParameter = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .meta({ format: 'camelCase' })
      .describe('Parameter name'),

    isArray: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this is an array'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Position in the parameter list'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description'),

    functionId: z.uuid().hidden().describe('Foreign key to ProcessFunction'),

    typeId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to ProcessDataType'),

    function: belongsTo('ProcessFunction'),

    type: references('ProcessDataType'),
  })
  .describe('A parameter on a process function.')
  .as('ProcessFunctionParameter');

export { processFunctionParameter as processFunctionParameterSchema };
